
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesQuotationBOMGrid extends Serenity.EntityGrid<SalesQuotationBOMRow, any> {
        protected getColumnsKey() { return 'Sales.QuotationBOM'; }
        protected getDialogType() { return SalesQuotationBOMDialog; }
        protected getIdProperty() { return SalesQuotationBOMRow.idProperty; }
        protected getInsertPermission() { return SalesQuotationBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesQuotationBOMRow.localTextPrefix; }
        protected getService() { return SalesQuotationBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}